import cssUtil from 'gw-portals-util-js/CssUtil';

import styles from './IndustryCode-hashed.scss';
import template from 'text!./IndustryCode.html';

export default [() => ({
    restrict: 'E',
    scope: {
        match: '=',
        query: '='
    },
    template: cssUtil.hashTemplate(template, styles)
})];